import { lighten } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => {
  const { palette, typography } = theme;
  const { pxToRem } = typography;

  return {
    root: {
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.common.white,
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        marginTop: pxToRem(0)
      }
    },
    paper: {
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(8, 4)
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(8, 8)
      },
      [theme.breakpoints.up('lg')]: {
        margin: theme.spacing(8, 20)
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    titleStyle: {
      marginTop: pxToRem(150),
      fontSize: pxToRem(30),
      fontFamily: 'circe-regular',
      color: palette.common.adminPrimary,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(23)
      }
    },
    titleStyleSuccess: {
      marginTop: pxToRem(170),
      marginBottom: pxToRem(40),
      fontSize: pxToRem(30),
      fontFamily: 'circe-regular',
      color: palette.common.adminPrimary,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(23)
      }
    },
    subtitleStyles: {
      fontSize: pxToRem(15),
      fontFamily: 'circe-regular',
      color: palette.common.adminPrimary,
      marginTop: pxToRem(5),
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(16)
      }
    },
    errorMsg: {
      fontSize: pxToRem(15),
      fontFamily: 'circe-regular',
      color: palette.error.main,
      marginTop: pxToRem(5),
      textAlign: 'center',
      fontWeight: '600',
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(16)
      }
    },
    gridContainerText: {
      height: pxToRem(40),
      width: pxToRem(350),
      marginBottom: pxToRem(25)
    },
    btnStyles: {
      marginTop: pxToRem(35),
      marginBottom: pxToRem(10),
      width: pxToRem(140),
      paddingTop: pxToRem(8),
      paddingBottom: pxToRem(8),
      textTransform: 'capitalize',
      color: palette.text.button,
      fontFamily: 'circe-regular',
      borderRadius: pxToRem(20),
      backgroundColor: palette.primary.main,
      '&.MuiButton-root:hover': {
        backgroundColor: lighten(palette.primary.main, 0.2)
      },
      '&.MuiButton-root.Mui-disabled': {
        color: palette.common.black,
        backgroundColor: palette.common.disabled
      },
      [theme.breakpoints.down('sm')]: { width: '100%' }
    },
    inputContainer: {
      height: pxToRem(30),
      width: pxToRem(38),
      margin: pxToRem(5),
      '& .MuiInputBase-input:focus': {
        borderWidth: pxToRem(1),
        borderColor: palette.common.grayColor
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    inputBackground: {
      width: pxToRem(170),
      height: pxToRem(5),
      borderStyle: 'solid',
      borderRadius: pxToRem(5),
      borderColor: palette.common.grayColor,
      borderWidth: pxToRem(1),
      paddingTop: pxToRem(16),
      paddingBottom: pxToRem(14),
      paddingLeft: pxToRem(15),
      fontFamily: 'circe-regular',
      fontSize: pxToRem(14),
      backgroundColor: lighten(palette.common.grayColor, 0.6),
      '&:-webkit-autofill': {
        transitionDelay: '9999s',
        transitionProperty: 'background-color, color'
      },
      '&:focus-within': {
        backgroundColor: palette.common.grayColor,
        borderColor: palette.common.grayColor
      }
    },
    gridContainer: {
      marginLeft: pxToRem(200)
    },
    resendCodeLink: {
      cursor: 'pointer',
      color: lighten(palette.common.black, 0.6),
      fontFamily: 'circe-regular',
      fontSize: pxToRem(12),
      [theme.breakpoints.down('md')]: {
        fontSize: pxToRem(12)
      }
    },
    textContainer: {
      marginTop: pxToRem(250)
    },
    textStyles: {
      fontSize: pxToRem(12),
      fontFamily: 'circe-regular',
      color: palette.common.adminPrimary
    },
    contactUsLink: {
      cursor: 'pointer',
      color: palette.primary.main,
      textDecorationColor: palette.primary.main,
      fontFamily: 'circe-regular',
      fontSize: pxToRem(15),
      [theme.breakpoints.down('md')]: {
        fontSize: pxToRem(15)
      }
    },
    btnStylesSuccess: {
      marginTop: pxToRem(35),
      marginBottom: pxToRem(10),
      width: pxToRem(180),
      paddingTop: pxToRem(8),
      paddingBottom: pxToRem(8),
      textTransform: 'capitalize',
      color: palette.common.white,
      fontFamily: 'circe-regular',
      borderRadius: pxToRem(20),
      backgroundColor: palette.success.main,
      '&.MuiButton-root:hover': {
        backgroundColor: lighten(palette.primary.main, 0.2)
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    icons: {
      color: palette.common.white,
      cursor: 'pointer'
    },
    loaderStyles: {
      marginTop: pxToRem(250),
      marginBottom: pxToRem(15),
      width: `${pxToRem(95)} !important`
    },
    textValue: {
      fontSize: pxToRem(15),
      fontFamily: 'circe-bold',
      color: palette.primary.main,
      lineHeight: pxToRem(18)
    },
    textDiv: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: pxToRem(300)
    }
  };
});

export { useStyles };
